<template>
    <div class=mainContainer>
    <div class="detailsContainer">
        <div class="cashBackTotal">
                <span class="label-text">
                    {{ $t('activity.cashBackTotal') }}
                </span>
                <span class="totalValue">
                    {{ formatCurrency(cashbackTotal) }}
                </span>
            </div>
        <div>
            <div v-if="isShowTodayCard">
                <CashBackHistoryCard :createTime="todayDayRewards.date" :total-amount="todayDayRewards.totalAmount" 
                    :istodayClaimed="istodayClaimed" :title="title" :day-list="todayDayRewards.rewards" />
            </div>
            <CashBackHistoryCard v-for="(item, index) in setBetList()" :key="index"
                :createTime="item.lossDate ?? item.createTime" :title="title" :day-count="item.dayCount ?? item.day"
                :activity-status="item.status"
                :total-amount="item.totalBetAmount ?? item.rechargeTotal ?? item.totalBetLoss"
                :istodayClaimed="istodayClaimed" :available-amount="item.remainGiftAmount ?? item.availableAmount"
                :day-list="setdayList(item.dayRewards)" />
        </div>

    </div>
   </div> 
</template>
<script lang="ts" setup>
import { PropType, ref, } from 'vue';
import CashBackHistoryCard from '../components/cashBackHistoryCard.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { getBetList, getDayList } from '@/view/components/supportFunction';

const props = defineProps({
    cashbackTotal: {
        type: Number,
        default: () => 0
    },
    betList: {
        type: Array as PropType<any[]>,
        default: () => []
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    type: {
        type: String,
        default: () => ''
    },
    title: String,
    todayDayRewards: {
        type: Object as PropType<any>
    },
    isShowTodayCard: {
        type: Boolean,
        default: () => false
    },
})
const showDetails = ref(false)
const handleDetailsShow = () => {
    showDetails.value = !showDetails.value
}
const setdayList = (data: any) => getDayList(props.type, data)
const setBetList = () => getBetList(props.betList, props.isShowTodayCard)
</script>
<style scoped>
.mainContainer{
    padding: 0px 15px 15px;
}
.detailsContainer {
    padding: 15px 15px;
    border-radius: 15px;
    color: #fff;
    background:#0000008c
}
.cashBackTotal {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 25px;
}

.label-text {
    font-size: 18px;
    font-weight: 700;
    color: #FFFFFF; 
    margin-bottom: 5px;
}

.totalValue {
    font-size: 38px;
    font-weight: 700;
    color: #89b8ff;
    line-height: 1;
    text-shadow: 0 0 15px #89b8ff, 0 0 30px #89b8ff;
}
</style>
